import React from "react";
import { useWidePopupStore } from "../../../api/Zustand";
import OpenAiWrapper from "../OpenAi/OpenAiWrapper";
import { useGptHistoryStore } from "../../../api/calls/OpenAi";
import { getLanguageFile } from "../../common/GetLanguageFile";

const WidePopup = (props: { tourID: number }) => {
  const { setIsOpen } = useWidePopupStore();

  const { resetHistory } = useGptHistoryStore();
  return (
    <div style={wrapperStyle}>
      <div style={panelStyle}>
        <header style={headerStyle}>
          {/* <div></div> */}
          <h3>OpenAi</h3>
          <button
            id="assetListClose"
            onClick={() => {
              setIsOpen(false);
              resetHistory();
            }}
          >
            {getLanguageFile("generics.close")}
          </button>
        </header>
        <OpenAiWrapper tourID={props.tourID} />
      </div>
    </div>
  );
};

export default WidePopup;

const wrapperStyle: React.CSSProperties = {
  position: "absolute",
  zIndex: "1100",
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#0008",
  color: "#222",
};

const panelStyle: React.CSSProperties = {
  // background: "#E8F0FF",
  background: "#fff",
  width: "75%",
  height: "90%",
  display: "flex",
  flexDirection: "column",
  zIndex: 5,
  borderRadius: 10,
};

const headerStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",

  paddingInline: 20,
  // height: "100px",
};
